export default [
  {
    path: "/",
    name: "index",
    component: () => import("@/views/Home/index.vue"),
    children: [
      {
        path: "/",
        name: "indexs",
        component: () => import("@/views/Indexs/index.vue"),
      },
    ],
  },
  {
    path: "/",
    name: "indexs",
    component: () => import("@/views/Home/index.vue"),
    redirect: "/home/index",
    children: [
      {
        path: "/index",
        name: "index",
        meta: {
          keepAlive: false,
        },
        component: () => import("@/views/Indexs/index.vue"),
      },
      {
        path: "/contactExample",
        name: "contactExample",
        meta: {
          keepAlive: false,
        },
        component: () => import("@/views/Indexs/contactExample.vue"),
      },
      {
        path: "/qualification",
        name: "qualification",
        component: () => import("@/views/qualification/index.vue"),
      },
      {
        path: "/engineDownload",
        name: "engineDownload",
        component: () => import("@/views/engineDownload/index.vue"),
      },
      {
        path: "/updateLog",
        name: "updateLog",
        component: () => import("@/views/updateLog/index.vue"),
      },
      {
        path: "/joinUs",
        name: "joinUs",
        component: () => import("@/views/joinUs/index.vue"),
      },
      {
        path: "/collaborate",
        name: "collaborate",
        component: () => import("@/views/collaborate/index.vue"),
      },
      {
        path: "/gameDetail",
        name: "gameDetail",
        component: () => import("@/views/gameDetail/index.vue"),
      },
      {
        path: "/user",
        name: "user",
        component: () => import("@/views/user/index.vue"),
      },
      {
        path: "/contactUs",
        name: "contactUs",
        component: () => import("@/views/user/contactUs.vue"),
      },
      {
        path: "/introduces",
        name: "introduces",
        component: () => import("@/views/user/introduces.vue"),
      },
      {
        path: "/childrenPlan",
        name: "childrenPlan",
        component: () => import("@/views/user/childrenPlan.vue"),
      },
      {
        path: "/userPlan",
        name: "userPlan",
        component: () => import("@/views/user/userPlan.vue"),
      },
      {
        path: "/news",
        name: "news",
        component: () => import("@/views/news/index.vue"),
      },
      {
        path: "/news/detail",
        name: "newsDetail",
        component: () => import("@/views/news/detail.vue"),
      },
      {
        path: "/versionCenter",
        name: "versionCenter",
        component: () => import("@/views/versionCenter/index.vue"),
      },
      {
        path: "/versionDetails",
        name: "versionDetails",
        component: () => import("@/views/versionDetails/index.vue"),
      },
    ],
  },
];
